import { Divider } from '@mui/material';

import {
  AutoComplete,
  ButtonGroup,
  Form,
  FormItem,
  Input,
} from '../../../../components';
import { type LatencyPeriod, LatencyPeriodOptions } from './const';
import { useLatencyMetrics } from './hooks/useLatencyMetrics';
import {
  LatencyTimeseriesCard,
  PercentilesByModelCard,
  ModelsSummaryTable,
  FallbacksCard,
  ToolCallsTable,
} from './components';

export const LatencyMetricsTab = () => {
  const {
    form,
    setForm,
    agentsOptions,
    metricOptions,
    preset,
    timeseries,
    percentiles,
    models,
    fallbacks,
    toolCalls,
  } = useLatencyMetrics();

  return (
    <>
      <div className="flex justify-between items-start m-4 gap-4">
        <div className="flex-1 min-w-0">
          <Form
            key="latency-filters"
            initialValue={{
              agentId: form.agentId,
              conversationId: form.conversationId,
              metricKey: form.metricKey,
            }}
            onChange={values =>
              setForm({
                ...form,
                agentId: values.agentId ?? '',
                conversationId: values.conversationId ?? '',
                metricKey: values.metricKey || form.metricKey,
              })
            }
          >
            <div className="flex flex-wrap gap-md items-center">
              <FormItem
                inline
                name="agentId"
                label="Agent:"
                labelClassName="text-small text-secondary"
                labelContainerClassName="min-h-0 min-w-0 whitespace-nowrap mr-1 self-center"
              >
                <AutoComplete options={agentsOptions} />
              </FormItem>
              <FormItem
                inline
                name="metricKey"
                label="Metric:"
                labelClassName="text-small text-secondary"
                labelContainerClassName="min-h-0 min-w-0 whitespace-nowrap mr-1 self-center"
              >
                <AutoComplete options={metricOptions} />
              </FormItem>
              <FormItem
                inline
                name="conversationId"
                label="Conversation:"
                labelClassName="text-small text-secondary"
                labelContainerClassName="min-h-0 min-w-0 whitespace-nowrap mr-1 self-center"
              >
                <Input placeholder="conversation id" />
              </FormItem>
            </div>
          </Form>
        </div>

        <div className="shrink-0 flex items-center">
          <ButtonGroup
            buttons={LatencyPeriodOptions.map(option => ({
              action: option.value,
              label: option.label,
              active: form.period === option.value,
            }))}
            orientation="horizontal"
            buttonClassName="p-4"
            labelClassName="whitespace-nowrap overflow-hidden text-ellipsis text-small font-semibold text-secondary"
            onClick={action =>
              setForm({ ...form, period: action as LatencyPeriod })
            }
          />
        </div>
      </div>

      <Divider className="m-4" />

      <div className="mx-2 sm:mx-4 lg:mx-sm pb-8">
        <div className="w-full max-w-screen-2xl mx-auto px-2 sm:px-4 space-y-4 sm:space-y-6">
          <LatencyTimeseriesCard
            data={timeseries.data}
            loading={timeseries.loading}
            period={form.period}
            metricLabel={preset.label}
            unit={preset.unit}
          />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
            <PercentilesByModelCard
              data={percentiles.data}
              loading={percentiles.loading}
              metricLabel={preset.label}
              unit={preset.unit}
            />
            <ModelsSummaryTable data={models.data} loading={models.loading} />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
            <FallbacksCard data={fallbacks.data} loading={fallbacks.loading} />
            <ToolCallsTable data={toolCalls.data} loading={toolCalls.loading} />
          </div>
        </div>
      </div>
    </>
  );
};
